import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

export const obtenerPacks = async (incluirInactivos = false) => {
	try {
		const url = incluirInactivos ? '/packs?incluir_inactivos=true' : '/packs';

		const response = await apiClient.get(url);
		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				throw new Error(errorData.error || 'Error al obtener los packs');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
